<template lang="html">
  <div class="vip-course-item">
    <div class="vip-course-item-image">
      <img :src="courseInfo.image" alt="">
    </div>
    <div class="vip-course-item-main">
      <h1 class="title">{{courseInfo.title}}</h1>
      <div class="desc">
        <p v-for="(item, index) in desc" :key="index">
          {{item}}
        </p>
      </div>
      <div class="price">
        <p>{{courseInfo.price}}</p>
        <div class="price-button">
          <img src="./images/price-button.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipCourseItem',
  props: ['courseInfo'],
  data () {
    return {
      desc: []
    }
  },
  watch: {
    courseInfo: {
      handler (val) {
        if (!val) return
        this.desc = val.recommendWord.split('\n')
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.vip-course-item {
  width: rem(612);
  height: rem(200);
  text-align: initial;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-image {
    width: rem(150);
    background: #fff;
    > img {
      width: 100%;
    }
  }
  &-main {
    .title {
      font-size: rem(30);
      color: #3C3737;
      font-weight: bolder;
      line-height: rem(43);
    }
    .desc {
      color: #A49B94;
      font-size: rem(24);
      line-height: rem(35);
    }
    .price {
      font-size: rem(30);
      width: rem(414);
      margin-top: rem(25);
      display: flex;
      justify-content: space-between;
      align-items: center;
      > p {
        font-weight: bolder;
        &:before {
          content: '￥';
          font-size: rem(30);
        }
        font-size: rem(48);
        color: #3C3737;
      }
      &-button {
        width: rem(180);
        > img {
          width: 100%;
        }
      }
    }
  }
}
</style>
